module.exports = __webpack_public_path__ + "assets/case.3c28a0ab0a5b85c60ce23948e552f604.png";